import { Component, computed, effect, inject, input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AppToastService, AppToastSeverity } from './toast.service';

export type AppToastPosition = 'top-right' | 'top-left' | 'top-center' | 'bottom-right' | 'bottom-left' | 'bottom-center';

const SEVERITY_ICONS: Record<AppToastSeverity, string> = {
  success: 'check-circle',
  info: 'info',
  warn: 'warning',
  error: 'warning',
};

/**
 * Toast outlet. Render once (in app.component) and show messages via AppToastService.
 */
@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AppToast {
  private readonly toastService = inject(AppToastService);

  public readonly position = input<AppToastPosition>('top-right');
  public readonly life = input(6000);

  public readonly message = this.toastService.message;
  public readonly iconClass = computed(() => {
    const message = this.message();
    return message ? `ph ph-${SEVERITY_ICONS[message.severity]}` : '';
  });

  constructor() {
    // Auto-dismiss each message after `life` ms; a newer message restarts the timer
    effect((onCleanup) => {
      if (!this.message()) return;
      const timeout = setTimeout(() => this.toastService.dismiss(), this.life());
      onCleanup(() => clearTimeout(timeout));
    });
  }

  public dismiss(): void {
    this.toastService.dismiss();
  }
}
